import React from 'react';
import ReactDOM from 'react-dom';
import './fonts/SpartanMB-Black.ttf';
import './index.css';
import {Gamestore} from './gamestore'
import * as PIXI from "pixi.js";
import App from "./core/index";


import {} from "./components/commongame/configuration/gameCommongameconfiguration";
import {} from "./components/buttonpanel/configuration/gameButtonpanelconfiguration";
import {} from "./components/basegame/configuration/gameBasegameconfiguration";
import {} from "./components/layout/configuration/gameLayoutconfiguration";
import {} from "./components/symbol/configuration/gameSymbolconfiguration";
import {} from "./components/landingsymbol/configuration/landingsymbolconfiguration";
import {} from "./components/reelgridcontainer/configuration/gameReelgridcontainerconfiguration";
import {} from "./components/autoplay/configuration/gameAutoplayConfiguration";
import {} from "./components/reelgrid/configuration/gameReelgridconfiguration";
import {} from "./components/freegame/configuration/gameFreegameconfiguration";
import {} from "./components/payline/configuration/GamePaylineconfiguration"
import {} from "./components/winCelebration/configuration/winCelebrationConfiguration";
import {} from "./components/paytable/configuration/paytableconfiguration";
import {} from "./components/overlay/configuration/gameOverlayconfiguration";
import {} from "./components/desktopSettingPanel/configuration/gameDesktopSettingPanelconfiguration";
import {} from "./components/mobViewPanel/configuration/gameMobViewPanelconfiguration";
import {} from "./components/playerMessage/configuration/gamePlayerMessageconfiguration";
import {} from "./components/gridcontainer/configuration/IGgridcontainerconfiguration"
import {} from "./components/flowManager/configuration/gameFlowManagerConfiguration";
import './customCss/mobilePaytable.css';
import './customCss/mobViewPanel.css';
import {} from "./components/sounds/configuration/GAMEsoundconfiguration";
import {} from "./components/banner/configuration/gameBannerConfiguration";
import {} from "./data/config";
import {
    configGame, constant
} from "./data/config";
import 'pixi-spine';
import GameApp from "./gameApp";

window.PIXI = PIXI;

class CoreGame extends App {

    getGameStart(langCode: string = "en"): JSX.Element {
        return (<></>);
    }
}

const coreStarted = new CoreGame({});
const script = document.createElement("script");

 script.src = "../../../f1x2games/infrastr_generic-framework/main.min.js";
 //script.src = "http://www.1x2-cloud-1.com/f1x2games/infrastr_generic-framework/main.min.js";
 script.async = true;

 document.body.appendChild(script);
ReactDOM.render(
    <div>
        <div>

            {<GameApp width={configGame.CANVAS_WIDTH} height={configGame.CANVAS_HEIGHT} configGame={configGame}
                      constant={constant} Gamestore={Gamestore} getGameStart={() => {
            }}/>}
              <div className="font-face-SpartanMB" style={{opacity:0.01, width:1}}>This is . </div>
              <div className="font-face-impact" style={{opacity:0.01, width:1}}>This is . </div>
              <div className="font-face-Dalelands" style={{opacity:0.01, width:1}}>This is  </div>
              <div className="font-face-NotoSansCJKsc-Regular" style={{opacity:0.01, width:1}}>This . </div>
              <div className="font-face-Oswald-Regular" style={{opacity:0.01, width:1}}>This  </div>
              <div className="font-face-Oswald-Light" style={{opacity:0.01, width:1}}>This i </div>
              <div className="font-face-Oswald-SemiBold" style={{opacity:0.01, width:1}}>This is Osw </div>
              <div className="font-face-NotoSansCJKsc-Bold" style={{opacity:0.01, width:1}}>This  Face. </div>
               {/* <div className="font-face-NotoSansCJKsc-Bold" style={{opacity:0.01}}>This is NotoSansCJKsc-Bold using Font Face. </div> */}
        </div>
    </div>
    ,
    document.getElementById('root')
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
